// Mobile hamburger nav — auto-injects into all pages
(function() {
  const nav = document.querySelector('.nav__inner');
  if (!nav) return;

  // Add hamburger button before nav__right
  const right = nav.querySelector('.nav__right');
  if (!right) return;

  const hamburger = document.createElement('button');
  hamburger.className = 'nav__hamburger';
  hamburger.setAttribute('aria-label', 'Menu');
  hamburger.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12h18M3 6h18M3 18h18"/></svg>';
  right.insertBefore(hamburger, right.firstChild);

  // Collect nav links
  const links = nav.querySelector('.nav__links');
  const linkItems = links ? Array.from(links.querySelectorAll('a')) : [];

  // Create mobile menu overlay
  const overlay = document.createElement('div');
  overlay.className = 'nav__mobile-menu';
  overlay.innerHTML = '<button class="nav__mobile-close" aria-label="Fechar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M18 6L6 18M6 6l12 12"/></svg></button>';

  // Clone links into mobile menu
  linkItems.forEach(function(a) {
    const clone = document.createElement('a');
    clone.href = a.href;
    clone.textContent = a.textContent;
    clone.addEventListener('click', function() { closeMenu(); });
    overlay.appendChild(clone);
  });

  document.body.appendChild(overlay);

  function openMenu() {
    overlay.style.display = 'flex';
    requestAnimationFrame(function() { overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    overlay.classList.remove('is-open');
    setTimeout(function() { overlay.style.display = 'none'; }, 300);
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  overlay.querySelector('.nav__mobile-close').addEventListener('click', closeMenu);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeMenu(); });
})();
